<!--Top Section-->
<div class="pt-2"></div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <h1 class="h2">Business Resources</h1>
  <!--buttons-->
  <div class="btn-toolbar d-flex justify-content-between  pt-3 pb-2 mb-3">
    <div class="col pb-3">
      <div class="btn-group pr-3">
        <!-- goBack() methos to back to previous component -->
        <a class="btn btn-sm btn-outline-secondary" href="https://forms.gle/n915nuAA4hYVYcGe6" value="feedback"
          target="_blank">Results Feedback</a>
      </div>
      <div class="btn-group pr-3">
        <!--button class="btn btn-sm btn-outline-secondary" (click)="toggle()">Download</button-->
        <button mat-raised-button color="primary" id="printbtn" (click)="exportOnClick()">Download PDF</button>
      </div>
      <div class="btn-group pr-3">
        <!-- goBack() methos to back to previous component -->
        <button class="btn btn-sm btn-outline-secondary" (click)="goBack()">Go Back</button>
      </div>
    </div>
  </div>
</div>

<div label="Additional Resources">
    <div>
      <p>SBA Census Business Builder Tool</p>
      <iframe width="310" height="175" src="https://www.census.gov/CBB/widget/embed_310x175.php" frameBorder="0"
        allowtransparency="true"></iframe>
    </div>
    <div>
      <!--  <div *ngIf="locationNameArray == 'City of Pittsburgh'; else test">
                                                                                                                                                                <img src="assets\imgs\GOGO.png">
                                                                                                                                                              </div>
                                                                                                                                                              <ng-template #test>
                                                                                                                                                              <p>{{locationNameArray}}Entrepreneurial
            journeys can involve some level of risk. The team’s ability to handle risk was rated as
            '{{data?.teamRisk?.name}}'.</p>
          </ng-template>-->
    </div>
</div>